export const esitoInvioEmailTableDataInitialState = {
    data: [],
    total: 0,
    loading: false,
}

export const esitoInvioEmailFilterOptionsInitialState = {
    data: {
        ntelefonoList: [],
        nserialeList: [],
        indirizzoEmailList: [],
        esitoInvioList: []
    },
    loading: false,
}

export const parametriESimTableInitialState = {
    data: [],
    total: 0,
    loading: false,
}

export const parametriESimFilterOptionsInitialState = {
    data: {
        numeroDiTelefonoList: [],
        nserialeList: [],
        statoSimList: [],
        emailInviataList: [],
    },
    loading: false,
}

export const initialImportDistribuzioneEsim = {
    data: {
        importaDistribuzioneDigitaleEsimList: [],
        errorMessage: "",
        hasError: false,
    },
    loading: false,
};

export const initialImportDistribuzioneEsimSostitutive = {
    data: {
        esimCsvValidationDistributionsItemList: [],
        errorMessage: "",
        hasError: false,
    },
    loading: false,
};

export const esitoCambioFormatoInitialState = {
    data: [],
    total: 0,
    loading: false,
};

export const esitoCambioFormatoFilterOptionsInitialState = {
    data: {
        esitoCambioFormato: [],
        numeroDiTelefono: [],
        numeroSeriale: [],
        dataInvioRichiesta: [],
        idLotto: []
    },
    loading: false,
}

export const sostitutiveListInitialState = {
    data: {
        autofillList: [],
        validationList: []
    },
    loading: false
}

export const initialImportCambioFormatoDistribuzione = {
    data: {
        esimCsvValidationDistributionsReplacementsItemList: [],
        errorMessage: "",
        hasError: false,
    },
    loading: false,
};

export const initialImportCambioFormato = {
    data: {
        rows: [],
        errorMessage: "",
        hasError: false,
    },
    loading: false,
};

export const initialImportTagsEsim = {
    data: [],
    loading: false,
};

export const initialInsertBatchAssociate = {
    data: [],
    loading: false,
};

export const initialRadioButtonValueState = {
    value:""
};